/**
 * Returns the URL for a stored image.
 * Images are served by Express from the uploads directory.
 */
export const imageUrl = (filename) => {
    if (!filename) return null;
    return `/api/v1/gallery/image/${filename}`;
};
